import { formatPrice } from '@/util/format'
import LabelMaker from './labelMaker'

export default class NoDiscountLabelMaker implements LabelMaker {
  public makeDiscountContentLabel(): string {
    return `-${formatPrice(0)}`
  }
}
